(function () {

  var MDCCheckbox = require('@material/checkbox/dist/mdc.checkbox.js').MDCCheckbox;
  var MDCFormField = require('@material/form-field/dist/mdc.formField.js').MDCFormField;

  var formFields = document.querySelectorAll('.js-checkbox');

  if (formFields) {
    [].forEach.call(formFields, function (checkboxFormField) {
      var checkboxElement = checkboxFormField.querySelector('.mdc-checkbox');
      var checkbox = new MDCCheckbox(checkboxElement);
      var formField = new MDCFormField(checkboxFormField);
      formField.input = checkbox;
    });
  }

})();
